import React, { useState, useEffect } from "react";
import axiosInstance from "../helpers/axiosInstance";
import Swal from "sweetalert2";

const VehicleParkingExit = () => {
  const [showModal, setShowModal] = useState(false);
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [loading, setLoading] = useState(false);

  // Auto open modal when component mounts
  useEffect(() => {
    setShowModal(true);
  }, []);

  // API call on submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!vehicleNumber.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Input",
        text: "Please enter a vehicle number",
      });
      return;
    }

    const payload = {
      Id: "TEST125",
      LprCameraName: "Gate1-Cam-A",
      PlateRead: vehicleNumber.trim(),
      timestamp: new Date().toISOString(),
      ContextImage: "https://via.placeholder.com/300x150.png?text=Truck+Image",
      sharpName: "Camera-Sharp",
    };

    try {
      setLoading(true);
      const response = await axiosInstance.post(
        `http://localhost:4000/api/auth/alpr?module=ParkingExit&gateNumber=1`,
        payload
      );

      // ✅ Check backend status and message
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.message || "Vehicle exit recorded successfully!",
        });
        setShowModal(false);
        setVehicleNumber("");
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message || "Unexpected response from server!",
        });
      }
    } catch (error) {
      console.error("Error calling API:", error);

      // ✅ Handle 404 or other error responses
      if (error.response && error.response.status === 404) {
        Swal.fire({
          icon: "error",
          title: "Not Found (404)",
          text: error.response.data.message || "Vehicle not found!",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error.response?.data?.message ||
            "Something went wrong while recording vehicle exit!",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" style={overlayStyle}>
          <div className="modal-content" style={modalStyle}>
            <h5 className="fw-bold text-center mb-3">🚗 Vehicle Parking Exit</h5>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Vehicle Number</label>
                <input
                  type="text"
                  className="form-control"
                  value={vehicleNumber}
                  onChange={(e) => setVehicleNumber(e.target.value)}
                  placeholder="Enter Vehicle Number"
                  required
                />
              </div>
              <div className="d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-success" disabled={loading}>
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

// Inline modal styles
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const modalStyle = {
  background: "#fff",
  borderRadius: "10px",
  padding: "20px",
  width: "400px",
  boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
};

export default VehicleParkingExit;
